import React from 'react';
import { CheckCircle2, BookText, ListChecks, FileSpreadsheet, SmartphoneNfc, MessageCircleHeart } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'Guía Legado Digital Seguro (PDF)',
    desc: 'El manual completo para organizar su vida digital sin estrés.',
    icon: <BookText className="w-8 h-8 text-gold" data-id="element-210" />
  }, {
    title: 'El Inventario de las 4 Cajas',
    desc: 'Una lista clara para identificar sus cuentas de banco, correos y redes sociales.',
    icon: <ListChecks className="w-8 h-8 text-gold" data-id="element-211" />
  }, {
    title: 'Plantilla del Ancla Analógica',
    desc: 'La hoja exacta para documentar sus Llaves Maestras.',
    icon: <FileSpreadsheet className="w-8 h-8 text-gold" data-id="element-212" />
  }, {
    title: 'Guía de Contactos de Legado',
    desc: 'Cómo configurar su iPhone o Android para que sus fotos pasen a sus hijos automáticamente.',
    icon: <SmartphoneNfc className="w-8 h-8 text-gold" data-id="element-213" />
  }, {
    title: 'El Script de la Conversación de Amor',
    desc: 'Qué decirles a sus hijos para que este proceso sea un momento de unión y no de tristeza.',
    icon: <MessageCircleHeart className="w-8 h-8 text-gold" data-id="element-214" />
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-217">
          Lo que recibirá hoy mismo
        </h2>
        <p className="text-xl text-center text-charcoal-light mb-12" data-id="element-218">
          Todo lo que necesita, diseñado con letra grande y explicaciones
          sencillas.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-219">
          {deliverables.map((item, index) => <div key={index} className={`bg-white p-8 rounded-sm shadow-warm border border-gold/20 flex gap-6 ${index === 4 ? 'md:col-span-2 md:w-2/3 md:mx-auto' : ''}`} data-id="element-220">
              <div className="shrink-0 mt-1" data-id="element-221">{item.icon}</div>
              <div data-id="element-222">
                <h3 className="text-2xl font-bold mb-2 text-burgundy flex items-center gap-2" data-id="element-223">
                  {item.title}
                </h3>
                <p className="text-lg text-charcoal-light leading-relaxed" data-id="element-224">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}